import React, { useCallback } from 'react';
import { message } from 'antd';
import { Header } from 'common/components/Header';
import { Content } from 'common/StyledComponents';
import {
  BusinessPartnerForm,
  BusinessPartnerFormModel,
} from 'pages/BusinessPartnerManagement/BusinessPartnerForm';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { useEnsureContext } from 'common/hooks';
import { useMutation, useQueryCache } from 'react-query';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { FormikOnSubmit } from 'lib/formik.utils';
import { QueryKey } from 'api/queryKey';
import { useHistory } from 'react-router';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const NewBusinessPartnerPage = () => {
  const queryCache = useQueryCache();
  const bpContext = useEnsureContext(BusinessPartnerContext);

  const [mutate, { isLoading }] = useMutation(
    BusinessPartnersAPI.createSubpartner
  );
  const history = useHistory();
  const intlMessage = useFormatMessage();

  const handleSubmit: FormikOnSubmit<BusinessPartnerFormModel> = useCallback(
    (formData, { resetForm }) => {
      mutate(
        { businessPartnerId: bpContext.id, dto: formData },
        {
          onSuccess: () => {
            resetForm();
            queryCache.invalidateQueries(QueryKey.BusinessPartnersList).then();
            message.success(
              intlMessage(
                { id: 'businessPartners.addNew.success' },
                { name: formData.name }
              )
            );
            history.push(`./`);
          },
        }
      ).then();
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bpContext, mutate, queryCache]
  );

  return (
    <Content>
      <Header title={intlMessage({ id: 'partners.addNew' })} />
      <BusinessPartnerForm
        isSubpartnerForm
        bpContextID={bpContext.id}
        onSubmit={handleSubmit}
        loading={isLoading}
      />
    </Content>
  );
};

// eslint-disable-next-line import/no-default-export
export default NewBusinessPartnerPage;
